module.exports = __webpack_public_path__ + "img/member.69f60764.svg";